/*main*/
function _(require, module, exports) {
    require(260    /* ./polyfill */);
    var version_1 = require(265    /* ./version */);
    exports.version = version_1.version;
    var embed = require(51    /* ./embed */);
    exports.embed = embed;
    var protocol = require(261    /* ./protocol */);
    exports.protocol = protocol;
    var logging_1 = require(14    /* ./core/logging */);
    exports.logger = logging_1.logger;
    exports.set_log_level = logging_1.set_log_level;
    var settings_1 = require(18    /* ./core/settings */);
    exports.settings = settings_1.settings;
    var base_1 = require(0    /* ./base */);
    exports.Models = base_1.Models;
    exports.index = base_1.index;
    var document_1 = require(50    /* ./document */);
    exports.documents = document_1.documents;
    var safely_1 = require(264    /* ./safely */);
    exports.safely = safely_1.safely;    
}